const context = require.context("../assets/providers", false, /\.(png|jpg|webp|svg)$/i);

export const normalizeAffiliateKey = (name) => (name || "").replace(/[\s_]+/g, "").toLowerCase();

const PROVIDER_ASSETS = {};

context.keys().forEach((key) => {
	const basename = key.replace(/^\.\//, "").replace(/\.[^.]+$/i, "");
	PROVIDER_ASSETS[normalizeAffiliateKey(basename)] = context(key);
});

export const getProviderAsset = (affiliate) =>
	PROVIDER_ASSETS[normalizeAffiliateKey(affiliate)] ?? null;
